import { useSyncExternalStore } from 'react';

/**
 * The "lens" (whose view): 'all' or a member id. Lives only as long as the app is open – every
 * start begins with "Alle" (Mike, 24.10.: "Default ist immer die Ansicht ‚alle‘ … jedes Mal, wenn
 * die App geöffnet wird").
 */
let lens = 'all';
const listeners = new Set<() => void>();

// until 1.25 the choice was remembered per device – drop the leftover
try {
  localStorage.removeItem('shh.lens.v1');
} catch {
  // storage blocked – nothing to clean
}

export function setLens(id: string) {
  if (id === lens) return;
  lens = id;
  listeners.forEach((l) => l());
}

export function useLensId(): string {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => lens,
  );
}

/** Whether something of `memberId` shows through the lens: everything for "Alle", else only theirs. */
export function shows(lensId: string, memberId: string): boolean {
  return lensId === 'all' || lensId === memberId;
}
